/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SignatureContact } from './signatureContact';
import type { SignatureField } from './signatureField';
import type { SignatureSocial } from './signatureSocial';
import type { SignatureTemplateConfigPhotoSide } from './signatureTemplateConfigPhotoSide';

export interface SignatureTemplateConfig {
  show_border?: boolean;
  show_divider?: boolean;
  socials_bordered?: boolean;
  show_photo?: boolean;
  photo_url?: string | null;
  photo_side?: SignatureTemplateConfigPhotoSide;
  /**
     * @minimum 48
     * @maximum 160
     */
  photo_size?: number;
  show_logo?: boolean;
  logo_url?: string | null;
  /**
     * @minimum 14
     * @maximum 64
     */
  logo_size?: number;
  /** @maxLength 100 */
  name?: string;
  /** @maxLength 120 */
  title?: string;
  /** @maxLength 120 */
  company?: string;
  contact?: SignatureContact;
  /** @maxItems 6 */
  additional_fields?: SignatureField[];
  /** @maxItems 8 */
  socials?: SignatureSocial[];
}
